import { hash } from '@ember/helper';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { and, eq } from 'ember-truth-helpers';
import GeneralTrackingTrackUsageAnalyticsHoverWrapper from 'lumen/components/general/tracking/track-usage-analytics-hover-wrapper';
import HotelPricingAssistantTableCellsTdCompetitorsRate from 'lumen/components/hotel/pricing-assistant/table/cells/td-competitors-rate';
import HotelPricingAssistantTableCellsTdOwnRate from 'lumen/components/hotel/pricing-assistant/table/cells/td-own-rate';
import HotelPricingAssistantTableCellsTdOwnRateDynamicRatePricing from 'lumen/components/hotel/pricing-assistant/table/cells/td-own-rate-dynamic-rate-pricing';
import type {
  TablePricingManagerCustomColumn,
  TablePricingManagerCustomRow,
} from 'lumen/components/hotel/pricing-assistant/table/table-pricing-manager';
import type { Carate, Rate } from 'lumen/models';

interface HotelPricingAssistantTableCellsTdRateCellDispatcherSignature {
  Args: {
    column: TablePricingManagerCustomColumn;
    row: TablePricingManagerCustomRow;
    value: Carate | Rate | null;
  };
}

// This component is used to dispatch the correct cell component, either the td-own-rate or the td-competitors-rate cell.
export default class HotelPricingAssistantTableCellsTdRateCellDispatcher extends Component<HotelPricingAssistantTableCellsTdRateCellDispatcherSignature> {
  @service declare access: Services['access'];
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  get isPast(): boolean {
    return this.hotelAndMarketService.isPast(this.args.column.date);
  }

  <template>
    {{#if @value}}
      {{#if (and @row.isOwnRateRow (eq @value.type "carate"))}}
        {{#if this.access.hasPricingAssistantDynamicRatePricingFeature}}
          <HotelPricingAssistantTableCellsTdOwnRateDynamicRatePricing
            @column={{@column}}
            @row={{@row}}
            {{! @glint-expect-error: Incorrect type }}
            @value={{@value}}
          />
        {{else}}
          <HotelPricingAssistantTableCellsTdOwnRate
            @column={{@column}}
            @row={{@row}}
            {{! @glint-expect-error: Incorrect type }}
            @value={{@value}}
          />
        {{/if}}
      {{else if (eq @value.type "rate")}}
        <GeneralTrackingTrackUsageAnalyticsHoverWrapper
          @eventName="Competitors Rates Previewed"
          @properties={{hash eventTrigger="table-view"}}
        >
          <HotelPricingAssistantTableCellsTdCompetitorsRate
            @column={{@column}}
            @row={{@row}}
            @value={{@value}}
          />
        </GeneralTrackingTrackUsageAnalyticsHoverWrapper>
      {{/if}}
    {{else}}
      <div
        class="mr-500 {{if this.isPast 'text-disabled' 'text-neutral-subdued'}}"
      >
        {{t "general.missing"}}
      </div>
    {{/if}}
  </template>
}
